import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { Tc, TcPerfilUsuarioEnum, EnumSiNoTodos } from '../../../core/_infrastructure/types/common';
import { ConfirmationService } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { HttpParams } from '@angular/common/http';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';

import { UsuariosService } from '.././usuarios.service';
import { UsuarioItemResultsViewModel, VListaUsuariosItemViewModel, FilterSearchingVListaUsuariosViewModel } from '../usuarios.types';

import { PuntoInspeccionUsuarioViewModel } from '../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.types';
import { PuntoInspeccionService } from '../../../_mantenimiento/general/puntosinspeccion/puntoinspeccion.service';

import { Table } from 'primeng/table';
import { SelectItem } from 'primeng/api';

@Component({
    selector: 'app-usuarioscexveg-list',
    templateUrl: './usuarioscexveg-list.component.html',
})
export class UsuarioscexvegListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultUsuariosCexveg: UsuarioItemResultsViewModel;
    listPerfilesUsuario: Tc[];
    listComunidadesAutonomas: Tc[];
    listProvincias: Tc[];
    listTcPerfilUsuarioCollection: Tc[];
    listPuntosInspeccion: PuntoInspeccionUsuarioViewModel[];
    model?: FilterSearchingVListaUsuariosViewModel;

    cols: any[];
    public selectedColumns: any[];

    visibilitySpinner = false;
    public isCollapsed = false;

    idPerfil: number;
    resultUsuariosCexvegCount: number;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private usuariosService: UsuariosService,
        private pifService: PuntoInspeccionService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultUsuariosCexveg = new UsuarioItemResultsViewModel();
    }

    ngOnInit() {
        this.recoverLastSearch();

        this.cols = [
            { field: 'ExpandLink', header: '', reduce: true },
            { field: 'Link', header: '', reduce: true },
            //{ field: 'Id', header: 'Id', display: 'none' },
            { field: 'Nombre', header: 'Nombre' },
            { field: 'Apellidos', header: 'Apellidos' },
            { field: 'NombreUsuarioCexveg', header: 'Usuario Cexveg' },
            { field: 'Nif', header: 'NIF' },
            { field: 'Email', header: 'Email' },
            { field: 'Activo', header: 'Activo' },
        ];

        this.selectedColumns = this.cols;

        this.globalService.getComunidadesAutonomas().subscribe(res => {
            this.listComunidadesAutonomas = res;
        });

        this.globalService.getProvincias().subscribe(res => {
            this.listProvincias = res;
        });

        //this.pifService.getPuntosInspeccionUsuarios().subscribe(result => {
        //    this.listPuntosInspeccion = result;
        //});

        this.form = this.fb.group({
            Nombre: '',
            Apellidos: '',
            IdPerfilUsuario: null,
            //IdZona: null,
            IdComunidadAutonoma: null,
            IdProvincia: null,
            Nif: '',
            Activo: EnumSiNoTodos.TODOS,
            IdPuntoInspeccion: null,
            Email: '',
            NombreUsuarioCexveg: '',
        });

        this.globalService.getPerfilesUsuarioCexveg().subscribe(result => {
            this.listPerfilesUsuario = result;

            //Si es coordinador y no Admin ni MAPA, solo se deja el perfil inspector.
            if (this.isCoordinador && (!this.isAdmin || !this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.Magrama))) {
                this.listPerfilesUsuario = this.listPerfilesUsuario.filter(
                    it => it.Id == TcPerfilUsuarioEnum.Inspector.valueOf() || it.Id == TcPerfilUsuarioEnum.Consultas.valueOf(),
                );

                this.form.controls['IdPerfilUsuario'].disable();

                this.form.patchValue({
                    IdPerfilUsuario: TcPerfilUsuarioEnum.Inspector.valueOf(),
                });

                this.idPerfil = TcPerfilUsuarioEnum.Inspector.valueOf();
            }
        });

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack(): void {
        if (
            //this.usuariosCexvegService.currentFilterUsuariosCexveg.Id != 0
            //||
            this.usuariosService.currentFilterUsuariosCexveg.Nombre != '' ||
            this.usuariosService.currentFilterUsuariosCexveg.Apellidos != '' ||
            this.usuariosService.currentFilterUsuariosCexveg.IdPerfilUsuario != null ||
            //|| this.usuariosService.currentFilterUsuariosCexveg.IdZona != null
            this.usuariosService.currentFilterUsuariosCexveg.IdComunidadAutonoma != null ||
            this.usuariosService.currentFilterUsuariosCexveg.IdProvincia != null ||
            this.usuariosService.currentFilterUsuariosCexveg.Nif != '' ||
            this.usuariosService.currentFilterUsuariosCexveg.Email != '' ||
            this.usuariosService.currentFilterUsuariosCexveg.NombreUsuarioCexveg != '' ||
            this.usuariosService.currentFilterUsuariosCexveg.IdPuntoInspeccion != null ||
            this.usuariosService.currentFilterUsuariosCexveg.Activo != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                //Id: this.usuariosCexvegService.currentFilterUsuariosCexveg.Id,
                Nombre: this.usuariosService.currentFilterUsuariosCexveg.Nombre,
                Apellidos: this.usuariosService.currentFilterUsuariosCexveg.Apellidos,

                IdPerfilUsuario: this.usuariosService.currentFilterUsuariosCexveg.IdPerfilUsuario,
                //IdZona: this.usuariosService.currentFilterUsuariosCexveg.IdZona,
                IdComunidadAutonoma: this.usuariosService.currentFilterUsuariosCexveg.IdComunidadAutonoma,
                IdProvincia: this.usuariosService.currentFilterUsuariosCexveg.IdProvincia,

                Nif: this.usuariosService.currentFilterUsuariosCexveg.Nif,
                Activo: this.usuariosService.currentFilterUsuariosCexveg.Activo,

                IdPuntoInspeccion: this.usuariosService.currentFilterUsuariosCexveg.IdPuntoInspeccion,
                Email: this.usuariosService.currentFilterUsuariosCexveg.Email,
                NombreUsuarioCexveg: this.usuariosService.currentFilterUsuariosCexveg.NombreUsuarioCexveg,
            });

            this.onSearchButton();
        }
    }

    onSelectComunidad() {
        if (this.form.value.IdComunidadAutonoma) {
            this.form.patchValue({
                IdProvincia: null,
                IdPuntoInspeccion: null,
            });

            this.globalService.getProvinciasByComunidad(this.form.value.IdComunidadAutonoma).subscribe(params => {
                this.listProvincias = params;
            });
        } else {
            this.form.patchValue({
                IdProvincia: null,
                IdPuntoInspeccion: null,
            });

            this.globalService.getProvincias().subscribe(res => {
                this.listProvincias = res;
            });
        }
    }

    onSelectProvincia(): void {
        this.pifService.getPuntosInspeccionUsuarios().subscribe(result => {
            this.listPuntosInspeccion = result.filter(it => it.IdProvincia == this.form.value.IdProvincia);
        });

        this.form.patchValue({
            IdPuntoInspeccion: null,
        });
    }

    onSearchButton(): void {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        //this.usuariosCexvegService.currentFilterUsuariosCexveg.Id = this.form.value.IdEstadoEnvioAduanas;
        this.usuariosService.currentFilterUsuariosCexveg.Nombre = this.form.value.Nombre;
        this.usuariosService.currentFilterUsuariosCexveg.Apellidos = this.form.value.Apellidos;
        this.usuariosService.currentFilterUsuariosCexveg.IdPerfilUsuario = this.form.value.IdPerfilUsuario;
        if (this.form.value.IdPerfilUsuario === undefined) {
            this.usuariosService.currentFilterUsuariosCexveg.IdPerfilUsuario = this.idPerfil;
        }
        //this.usuariosService.currentFilterUsuariosCexveg.IdZona = this.form.value.IdZona;
        this.usuariosService.currentFilterUsuariosCexveg.IdComunidadAutonoma = this.form.value.IdComunidadAutonoma;
        this.usuariosService.currentFilterUsuariosCexveg.IdProvincia = this.form.value.IdProvincia;
        this.usuariosService.currentFilterUsuariosCexveg.Nif = this.form.value.Nif;
        this.usuariosService.currentFilterUsuariosCexveg.Activo = this.form.value.Activo;

        this.usuariosService.currentFilterUsuariosCexveg.IdPuntoInspeccion = this.form.value.IdPuntoInspeccion;
        this.usuariosService.currentFilterUsuariosCexveg.Email = this.form.value.Email;
        this.usuariosService.currentFilterUsuariosCexveg.NombreUsuarioCexveg = this.form.value.NombreUsuarioCexveg;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    onSearchDetalle(rowData: VListaUsuariosItemViewModel): void {
        let id = rowData.Id;

        this.usuariosService.getPerfilesByIdUsuario(id).subscribe(res => {
            this.listTcPerfilUsuarioCollection = res;
        });
    }

    Search(pageNumber: number, asc = 0, orderBy = ''): void {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('nombre', this.form.value.Nombre);
        params = params.append('apellidos', this.form.value.Apellidos);

        if (!this.form.controls['IdPerfilUsuario'].disabled) {
            params = params.append('idPerfilUsuario', this.form.value.IdPerfilUsuario);
            if (this.form.value.IdPerfilUsuario === undefined) {
                this.usuariosService.currentFilterUsuariosCexveg.IdPerfilUsuario = this.idPerfil;
            }
        } else {
            //Por el problema de los controles en disable
            params = params.append('idPerfilUsuario', this.idPerfil.toString());
        }

        //params = params.append('idZona', this.form.value.IdZona);
        params = params.append('idComunidadAutonoma', this.form.value.IdComunidadAutonoma);
        params = params.append('idProvincia', this.form.value.IdProvincia);
        params = params.append('nif', this.form.value.Nif);
        params = params.append('activo', this.form.value.Activo);

        params = params.append('email', this.form.value.Email);
        params = params.append('nombreUsuarioCexveg', this.form.value.NombreUsuarioCexveg);
        params = params.append('idPuntoInspeccion', this.form.value.IdPuntoInspeccion);

        this.loading = true;
        this.usuariosService.getUsuariosCexvegPagedByFilter(params).subscribe(result => {
            this.resultUsuariosCexveg = result;
            this.resultUsuariosCexvegCount = result.TotalCount;
            this.loading = false;
        });
    }

    onSearchLazy(event: any): void {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton(): void {
        this.form.setValue({
            Nombre: '',
            Apellidos: '',
            IdPerfilUsuario: null,
            //IdZona: null,
            IdComunidadAutonoma: null,
            IdProvincia: null,
            Nif: '',
            Activo: EnumSiNoTodos.TODOS,
            Email: '',
            NombreUsuarioCexveg: '',
            IdPuntoInspeccion: null,
        });

        this.searchingButton = false; //??

        this.isCollapsed = false;

        this.resultUsuariosCexveg = new UsuarioItemResultsViewModel();
    }

    onAdd(): void {
        this.router.navigate(['/mantenimiento/usuarios/usuarioscexveg/create']);
    }

    onEdit(item: VListaUsuariosItemViewModel): void {
        this.router.navigate(['/mantenimiento/usuarios/usuarioscexveg/edit', item.Id]);
    }

    onDelete(item: VListaUsuariosItemViewModel): void {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.usuariosService.deleteUsuario(item.Id).subscribe(res => {
                    this.addSuccessMessage('Usuario Cexveg eliminado correctamente');
                    this.onSearchButton();
                });
            },
        });
    }

    CreateModel(): any {
        let model: FilterSearchingVListaUsuariosViewModel = new FilterSearchingVListaUsuariosViewModel();

        Object.assign(model, this.form.value);

        if (this.form.value.IdPerfilUsuario === undefined) {
            model.IdPerfilUsuario = this.idPerfil;
        }

        return model;
    }

    onExportExcel(): void {
        this.visibilitySpinner = true;

        this.usuariosService.exportUsuariosCexveg(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            this.visibilitySpinner = false;
        });
    }

    private recoverLastSearch() {
        this.model = this.usuariosService.getLastSearchUsuariosCexveg();

        if (this.model?.IdComunidadAutonoma) {
            this.globalService.getProvinciasByComunidad(this.model?.IdComunidadAutonoma).subscribe(params => {
                this.listProvincias = params;
            });
            if (this.model?.IdProvincia) {
                this.pifService.getPuntosInspeccionUsuarios().subscribe(result => {
                    this.listPuntosInspeccion = result.filter(it => it.IdProvincia == this.model?.IdProvincia);
                });
            }
        }
    }
}
